<template>
  <section ref="main" class="app-home">
    <LazyModuleCLNew v-if="moduleCLNewData" :title="moduleCLNewData.title" :list="moduleCLNewData.news_banners" />
    <LazyModuleCLEvents
      v-if="moduleCLEventsData"
      :list="moduleCLEventsData.events"
      :title="moduleCLEventsData.title"
      :ratio="26.5 / 9"
    />
  </section>
</template>
<script lang="ts" setup>
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['index-page-cache-tag'])
})
const { fetchPageData, filterModule } = usePageStore()
await fetchPageData('/cl/')
const moduleCLNewData = filterModule('ModuleCLNew')
const moduleCLEventsData = filterModule('ModuleCommonEvents')
</script>
<style lang="scss" scoped></style>
